<app-page-header [title]="'Sample Hardware Revisions'" [subtitle]="'Manage Sample Hardware Revisions for Sample Studio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="sample_hardware_revision_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="sample_hardware_revision_search">Search Sample Hardware Revision</label>
        </p-ifta-label>
        <p-button label="Add Sample Hardware Revision" icon="pi pi-plus" (click)="this.openCreateSampleHardwareRevisionDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table 
                [value]="this.sampleHardwareRevisions"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
                paginatorDropdownAppendTo="body"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Hardware Revision</th>
                    <th>Description</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-sampleHardwareRevision>
                <tr>
                    <td>{{ sampleHardwareRevision.pcbVersion }}</td>
                    <td>{{ sampleHardwareRevision.description }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit sample hardware revision"
                                      tooltipPosition="left"
                                      (click)="this.editSampleHardwareRevision(sampleHardwareRevision)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="[Disabled] Delete sample hardware revision"
                                      tooltipPosition="left"
                                      (click)="this.deleteSampleHardwareRevision(sampleHardwareRevision)"
                                      severity="danger"
                                      disabled='false'></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- Create Sample Hardware Revision Dialog -->
<app-create-sample-hardware-revision-dialog
        [(visible)]="this.displayCreateSampleHardwareRevisionDialog"
        (sampleHardwareRevisionCreated)="this.reloadSampleHardwareRevisions()"
></app-create-sample-hardware-revision-dialog>

<!-- Update Sample Hardware Revision Dialog -->
<app-update-sample-hardware-revision-dialog
        [(visible)]="this.displayUpdateSampleHardwareRevisionDialog"
        [sampleHardwareRevision]="this.selectedSampleHardwareRevision"
        (sampleHardwareRevisionUpdated)="this.reloadSampleHardwareRevisions()"
></app-update-sample-hardware-revision-dialog>